import { ContractCaptureType } from './../../features/settings/models/contract-capture-type.model';
import { FormGroup } from '@angular/forms';
import { createAction, props } from '@ngrx/store';
import { SysContractStatus } from 'app/core/models/sys-contract-status.model';
import { AircraftWarrantyHistory } from 'app/features/contracts/models/aircraft-warranty-history.model';
import { ContractFlightCardComponent } from 'app/features/contracts/models/contract-flight-card-component.model';
import { Contract } from 'app/features/contracts/models/contract.model';
import { ContractGroupType } from 'app/features/settings/models/contract-group-type.model';
import { ContractProgram } from 'app/features/settings/models/contract-program.model';
import { RateEscalationType } from 'app/features/settings/models/rate-escalation-type.model';
import { SysFlightCardComponentType } from 'app/core/models/sys-flight-card-component-type.model';
import { SysFlightCardComponent } from 'app/features/contracts/models/sys-flight-card.component.model';
import { ContractBillingEntity } from 'app/features/contracts/models/contract-billing-entity.model';
import { AdminStaff } from 'app/features/manage/models/admin-staff.model';
import { SysContractStatusChangeReason } from 'app/core/models/sys-contract-status-change-reason.model';
import { ContractTransfer } from 'app/features/contracts/models/contract-transfer.model';
import { SysClientReportType } from 'app/core/models/sys-client-report-types.model';
import { Product } from 'app/features/settings/models/product.model';
import { ContractEntity } from 'app/features/contracts/models/contract-entity.model';
import { ContractGroupingForAnalytics } from 'app/features/settings/models/contract-grouping-for-analytics.model';
import { NextFlightCard } from 'app/features/contracts/models/next-flight-card.model';
import { ContractProduct } from 'app/features/contracts/models/contract-product.model';

// Contract
export const triggerAllContractGridAPIs = createAction('[Contract] Load Contracts Grid');

export const triggerContracts = createAction('[Contract] Load Contracts');
export const contractsSuccess = createAction(
  '[Contract] Contracts Success',
  props<{ contracts: Contract[] }>()
);

export const contractsFailure = createAction(
  '[Contract]  Contracts Failure',
  props<{ error: string }>()
);

//Edit Contract
export const triggerEditContract = createAction(
  '[Contract] Edit Contract',
  props<{ formGroup: FormGroup }>()
);
export const EditContractSuccess = createAction(
  '[Contract]  Edit Contract Success',
  props<{ contract: Contract }>()
);
export const EditContractFailure = createAction(
  '[Contract]  Edit Contract Failure',
  props<{ error: string }>()
);
export const setCurrentContract = createAction(
  '[Contract] Set contract-edit object',
  props<{ currentContract: Contract }>()
);
export const setCurrentContractWithOutSideEffects = createAction(
  '[Contract] Set contract-edit object w/o side effects',
  props<{ currentContract: Contract }>()
);

export const setCurrentContractForInvoice = createAction(
  '[Contract] Set contract-edit object with Invoice related effects',
  props<{ currentContract: Contract }>()
);

export const setContractPopUpTitle = createAction(
  '[Contract] Set Contract PopUpTitle',
  props<{ popupTitle: string }>()
);

//Add Contract
export const triggerAddContract = createAction(
  '[Contract] Add Contract',
  props<{ formGroup: FormGroup }>()
);
export const AddContractSuccess = createAction(
  '[Contract]  Add Contract Success',
  props<{ contract: Contract }>()
);
export const AddContractFailure = createAction(
  '[Contract]  Add Contract Failure',
  props<{ error: string }>()
);

export const updateGridAfterAddContractSuccess = createAction(
  '[Contract] Update Grid After Add Contract Success',
  props<{ addedContractId: number }>()
);

export const resetAddedContractSlice = createAction('[Contract] Reset Added Contract Success');

// Contract Group Types
export const triggerContractGroupTypes = createAction(
  '[Contract Group Types] Trigger Contract Group Types'
);
export const contractGroupTypesSuccess = createAction(
  '[Contract Group Types] Contract Group Types Success',
  props<{ contractGroupTypes: ContractGroupType[] }>()
);
export const contractGroupTypesFailure = createAction(
  '[Contract Group Types] Contract Group Types Failure',
  props<{ error: string }>()
);

// Contract Programs
export const triggerContractPrograms = createAction('[Contract Programs] Load Contract Programs');
export const contractProgramsSuccess = createAction(
  '[Contract Programs] Load Contract Programs Success',
  props<{ contractPrograms: ContractProgram[] }>()
);
export const contractProgramsFailure = createAction(
  '[Contract Programs] Load Contract Programs Failure',
  props<{ error: string }>()
);

// Sys Flight Card Components
export const triggerSysFlightCardComponents = createAction(
  '[Sys Flight Card Components] Load Sys Flight Card Components'
);
export const sysFlightCardComponentsFailure = createAction(
  '[Sys Flight Card Components] Load Sys Flight Card Components Failure',
  props<{ error: string }>()
);

// Update individual properties of contract object
export const setAccountManagerDetails = createAction(
  '[Contract] Set Account Manager Name for Curr Contract',
  props<{ accountManagerName: string; accountManagerId: number }>()
);

export const setLatestContractStatusDetails = createAction(
  '[Contract] Set Latest status for Curr Contract',
  props<{
    contractStatusName: string;
    contractStatusId: number;
    contractTransactionEndDate: string;
  }>()
);

export const setEstimatedAndAnnouncedValue = createAction(
  '[Contract] Set Estimated value for Curr Contract',
  props<{ estimatedValue: number; announcedValue: number }>()
);

export const setWarrantyInfo = createAction(
  '[Contract] Set warranty info for Curr Contract',
  props<{ warrantyInfo: AircraftWarrantyHistory }>()
);

// Contract Capture Types
export const setContractCaptureTypesSuccess = createAction(
  '[Contract Capture Types] Load Contract Capture Types Success',
  props<{ contractCaptureTypes: ContractCaptureType[] }>()
);

// Contract Flight Card Components
export const setContractFlightCardComponents = createAction(
  '[Contract] Update Contract Flight Card Components',
  props<{ contractFlightCardComponents: ContractFlightCardComponent[] }>()
);

export const updateContractFlightCardComponents = createAction(
  '[Contract] modify Contract Flight Card Components',
  props<{ contractId: number }>()
);

export const clearContractFlightCardComponents = createAction(
  '[Contract] clear Contract Flight Card Components'
);

export const setSysFlightCardComponents = createAction(
  '[Contract] Flight Card Components Success',
  props<{ sysFlightCardComponents: SysFlightCardComponent[] }>()
);

export const setSysFlightCardComponentTypes = createAction(
  '[Contract] Flight Card Components Types Success',
  props<{ sysFlightCardComponentTypes: SysFlightCardComponentType[] }>()
);

// Rate Escalation Types
export const setRateEscalationSuccess = createAction(
  '[Rate Escalation Types] Load Contract Rate Escalation Types Success',
  props<{ rateEscalation: RateEscalationType[] }>()
);

// Contract Billing Entities
export const setContractBillingEntitySuccess = createAction(
  '[Contract Billing Entities] Load Contract Billing Entities Success',
  props<{ contractBillingEntities: ContractBillingEntity[] }>()
);

// Contract Entities
export const setContractEntitySuccess = createAction(
  '[Contract Entities] Load Contract Entities Success',
  props<{ contractEntities: ContractEntity[] }>()
);

// Contract action for revenue menu
export const setFlightCardComponentsForRevenue = createAction(
  '[Contract] set Flight Card Components For Revenue menu',
  props<{ contractId: number }>()
);

// Admin Staffs
export const setAdminStaffs = createAction(
  '[Admin Staffs] set Admin Staffs',
  props<{ adminStaffs: AdminStaff[] }>()
);
export const clearAdminStaffs = createAction('[Contract] clear Contract Account Manager');

export const getAdminStaffs = createAction('[Admin Staffs] Load Admin Staffs');

// Sys Contract Statuses
export const setSysContractStatuses = createAction(
  '[Sys Contract Statuses] set Sys Contract Statuses',
  props<{ sysContractStatuses: SysContractStatus[] }>()
);

export const getSysContractStatusesAndChangeReasons = createAction(
  '[Sys Contract Statuses] Load SysContract Statuses and Change Reasons'
);

// Sys Contract Status Change Reasons
export const setSysContractStatusChangeReasons = createAction(
  '[Sys Contract Status Change Reasons] set Sys Contract Status Change Reasons',
  props<{ sysContractStatusChangeReasons: SysContractStatusChangeReason[] }>()
);

//ContractTransfers

export const loadContractTransfers = createAction(
  '[ContractTransfers] Load ContractTransfers',
  props<{ contractId: number }>()
);

export const loadContractTransfersSuccess = createAction(
  '[ContractTransfers] Load ContractTransfers Success',
  props<{ contractTransfers: ContractTransfer[] }>()
);

export const updateContractTransfers = createAction(
  '[Contract] Update Contract Transfers',
  props<{ transfers: ContractTransfer[] }>()
);

export const setSysClientReportTypes = createAction(
  '[Contract] Client Report Types Success',
  props<{ sysClientReportTypes: SysClientReportType[] }>()
);

export const setProductSuccess = createAction(
  '[Contract Product] Load Product Success',
  props<{ products: Product[] }>()
);

export const contractGroupingForAnalyticSuccess = createAction(
  '[Contract Grouping Analytics] Contract Grouping Analytics Success',
  props<{ contractGroupingAnalytics: ContractGroupingForAnalytics[] }>()
);

export const triggerContractProductShortNames = createAction(
  '[Contract] Trigger Contract Product Short Names',
  props<{ currentContract: Contract }>()
);

export const setContractProductShortNames = createAction(
  '[Contract] Set Contract Product Short Names',
  props<{ contractProductShortNames: string }>()
);

export const setContractProductSuccess = createAction(
  '[Contract] Set Contract Products',
  props<{ contractProducts: ContractProduct[] }>()
);

export const triggerContractProducts = createAction(
  '[Contract] Trigger Contract Products',
  props<{ currentContract: Contract }>()
);

export const setContractNextFlightCard = createAction(
  '[Contract] Set Contract Next Flight Card',
  props<{ nextFlightCards: NextFlightCard[] }>()
);

export const clearContractProductShortNames = createAction(
  '[Contract] clear Contract Product Short Names'
);

export const adminStaffsForRegionalSalesManager = createAction(
  '[Contract Regional Sales Manager] Admin Staff Regional Sales Manager Success',
  props<{ regionalSaleManagerStaffs: AdminStaff[] }>()
);
